import { normalizeAssetIdFormat } from "@repo/types";

export const ONDO_BNB_CHAIN_ID = 56 as const;

interface OndoBnbMag7Asset {
  readonly address: `0x${string}`;
  readonly symbol: string;
  readonly underlyingSymbol: string;
}

export const ONDO_BNB_MAG7_ASSETS = [
  {
    address: "0x390a684ef9cade28a7ad0dfa61ab1eb3842618c4",
    symbol: "AAPLon",
    underlyingSymbol: "AAPL",
  },
  {
    address: "0x6bfe75d1ad432050ea973c3a3dcd88f02e2444c3",
    symbol: "MSFTon",
    underlyingSymbol: "MSFT",
  },
  {
    address: "0x4553cfe1c09f37f38b12dc509f676964e392f8fc",
    symbol: "AMZNon",
    underlyingSymbol: "AMZN",
  },
  {
    address: "0xa9ee28c80f960b889dfbd1902055218cba016f75",
    symbol: "NVDAon",
    underlyingSymbol: "NVDA",
  },
  {
    address: "0x091fc7778e6932d4009b087b191d1ee3bac5729a",
    symbol: "GOOGLon",
    underlyingSymbol: "GOOGL",
  },
  {
    address: "0xd7df5863a3e742f0c767768cdfcb63f09e0422f6",
    symbol: "METAon",
    underlyingSymbol: "META",
  },
  {
    address: "0x2494b603319d4d9f9715c9f4496d9e0364b59d93",
    symbol: "TSLAon",
    underlyingSymbol: "TSLA",
  },
] as const satisfies readonly OndoBnbMag7Asset[];

export const ONDO_BNB_MAG7_SYMBOLS = ONDO_BNB_MAG7_ASSETS.map(
  (asset) => asset.symbol,
);

export const ONDO_BNB_MAG7_UNDERLYING_SYMBOLS = ONDO_BNB_MAG7_ASSETS.map(
  (asset) => asset.underlyingSymbol,
);

export const ONDO_BNB_MAG7_ASSET_IDS = ONDO_BNB_MAG7_ASSETS.map((asset) =>
  normalizeAssetIdFormat(`${asset.address}:${ONDO_BNB_CHAIN_ID}`),
);
